import React from "react";

import { StyledSVG } from "../StyledIcon";

export const TicketIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_2142_41145)">
        <path
          d="M15.5 15L15.5 15.75L15.5 15ZM16.5 14L15.75 14L16.5 14ZM2.5 15L2.5 14.25L2.5 15ZM1.5 14L0.749998 14L1.5 14ZM1.5 10.5L1.5 9.75C1.08579 9.75 0.749999 10.0858 0.749998 10.5L1.5 10.5ZM1.5 7.5L0.75 7.5C0.75 7.91422 1.08579 8.25 1.5 8.25L1.5 7.5ZM1.5 4L0.749999 4L1.5 4ZM16.5 4L15.75 4L16.5 4ZM16.5 7.5L16.5 8.25C16.6989 8.25 16.8897 8.17098 17.0303 8.03033C17.171 7.88968 17.25 7.69891 17.25 7.5L16.5 7.5ZM15 9L15.75 9L15 9ZM16.5 10.5L17.25 10.5C17.25 10.3011 17.171 10.1103 17.0303 9.96967C16.8897 9.82902 16.6989 9.75 16.5 9.75L16.5 10.5ZM15.5 15.75C16.4665 15.75 17.25 14.9665 17.25 14L15.75 14C15.75 14.1381 15.6381 14.25 15.5 14.25L15.5 15.75ZM2.5 15.75L15.5 15.75L15.5 14.25L2.5 14.25L2.5 15.75ZM0.749998 14C0.749998 14.9665 1.5335 15.75 2.5 15.75L2.5 14.25C2.36193 14.25 2.25 14.1381 2.25 14L0.749998 14ZM0.749998 10.5L0.749998 14L2.25 14L2.25 10.5L0.749998 10.5ZM2.25 9C2.25 9.41421 1.91421 9.75 1.5 9.75L1.5 11.25C2.74264 11.25 3.75 10.2426 3.75 9L2.25 9ZM1.5 8.25C1.91421 8.25 2.25 8.58579 2.25 9L3.75 9C3.75 7.75736 2.74264 6.75 1.5 6.75L1.5 8.25ZM0.749999 4L0.75 7.5L2.25 7.5L2.25 4L0.749999 4ZM2.5 2.25C1.5335 2.25 0.749999 3.0335 0.749999 4L2.25 4C2.25 3.86193 2.36193 3.75 2.5 3.75L2.5 2.25ZM15.5 2.25L2.5 2.25L2.5 3.75L15.5 3.75L15.5 2.25ZM17.25 4C17.25 3.0335 16.4665 2.25 15.5 2.25L15.5 3.75C15.6381 3.75 15.75 3.86193 15.75 4L17.25 4ZM17.25 7.5L17.25 4L15.75 4L15.75 7.5L17.25 7.5ZM15.75 9C15.75 8.58579 16.0858 8.25 16.5 8.25L16.5 6.75C15.2574 6.75 14.25 7.75736 14.25 9L15.75 9ZM16.5 9.75C16.0858 9.75 15.75 9.41421 15.75 9L14.25 9C14.25 10.2426 15.2574 11.25 16.5 11.25L16.5 9.75ZM17.25 14L17.25 10.5L15.75 10.5L15.75 14L17.25 14Z"
          fill={iconColor}
        />
        <path
          d="M10.5 15L10.5 3"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2142_41145">
          <rect width="18" height="18" fill="white" transform="translate(18 18) rotate(-180)" />
        </clipPath>
      </defs>
    </StyledSVG>
  );
};
